import { useMutation, useQueryClient } from "@tanstack/react-query";
import { TERMS_VERSION, type CurrentUserProfile } from "@school-sales-ai/shared";
import { api } from "@/lib/api";
import { CURRENT_USER_QUERY_KEY } from "@/hooks/useUsers";

/**
 * Records that the signed-in user accepted the Términos y condiciones this CRM
 * build displays. Sends `TERMS_VERSION` — the text on screen — rather than
 * asking the backend what "current" is: the two deploy separately.
 *
 * On success the cached profile is patched in place, so the gate opens at once
 * instead of waiting for a refetch of `/crm/users/me`.
 */
export function useAcceptTerms() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.post<{ termsAcceptedVersion: string }>("/crm/terms/accept", {
        version: TERMS_VERSION,
      }),
    onSuccess: ({ termsAcceptedVersion }) => {
      queryClient.setQueryData<CurrentUserProfile>(CURRENT_USER_QUERY_KEY, (profile) =>
        profile ? { ...profile, termsAcceptedVersion } : profile,
      );
    },
  });
}
